import { HolidaysService } from '@/services/holidays.service';

export default {
  getHolidays({ commit }, { params } = {}) {
    return HolidaysService.getList(params).then(response => {
      commit('setHolidays', response.data.data);

      return response;
    });
  }
};
